// Master Apps · estado do Inventário — sobrevive à navegação (em memória).
//
// Abrir a ficha de um app e voltar não pode zerar chips, busca, ordenação,
// filtros de coluna nem a página que o usuário montou. Diferente do
// catalog-prefs, aqui NADA vai para localStorage: o que precisa sobreviver é a
// ida-e-volta dentro da sessão; recarregar a página começa limpo de propósito.
//
// O mesmo componente atende duas telas (Inventário e Apps internos), então o
// estado vive por CHAVE (`active` da tela) — uma não contamina o recorte da
// outra. Os DEFAULTS ficam na tela: só ela conhece o `initialFilter`.
import { create } from 'zustand';
import type { ColunaTabela, OrdemTabela } from '@/lib/inventory-columns';

export interface InventoryTableState {
  filter: string;
  query: string;
  page: number;
  pageSize: number;
  ordem: OrdemTabela;
  filtroCol: Partial<Record<ColunaTabela, string>>;
}

interface InventoryPrefsStore {
  byKey: Record<string, InventoryTableState>;
  /** Grava o estado COMPLETO da tela `key` — a tela mescla o parcial antes. */
  save: (key: string, state: InventoryTableState) => void;
}

export const useInventoryPrefs = create<InventoryPrefsStore>((set) => ({
  byKey: {},
  save: (key, state) => set((s) => ({ byKey: { ...s.byKey, [key]: state } })),
}));
